import * as React from 'react';

import type { EntityIconProps } from '@klareospace/pharos-lib-web-utils';
import { EntityIcon } from '@klareospace/pharos-lib-web-utils';
import { Plug } from 'lucide-react';

// ─── Types ────────────────────────────────────────────────────────────────────

interface ShipperAvatarProps {
  className?: string;
  logoUrl?: string;
  name: string;
  /** Avatar size variant (defaults to "sm" for table rows, use "md" for drawer identity). */
  size?: EntityIconProps['size'];
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ShipperAvatar({ className, logoUrl, name, size = 'sm' }: ShipperAvatarProps): React.JSX.Element {
  return <EntityIcon alt={name} className={className} fallbackIcon={Plug} size={size} src={logoUrl} />;
}
